import {AnyAction, ThunkDispatch} from '@reduxjs/toolkit';
import {handleError} from '@store/app.slice';
import {mapLaravelErrorPayload} from '../constants/laravelValidationMessages';
import {IError} from './types';


export const helperHandleError = (fc: string, error: any, dispatch: ThunkDispatch<unknown, unknown, AnyAction>): IError => {
    dispatch(handleError(mapLaravelErrorPayload(error.response?.data)));
    throw error;
};
